import {
  Entity,
  Mate,
  Media,
  Moment,
  Reply,
  StoryBook,
  Visibility,
} from "./entity";
import { GalGame } from "./galGameEditor";

export enum MomentVisibility {
  Public = 1,
  SelfOnly = 2,
  FollowerOnly = 3,
  AdmirerOnly = 4,
  Hidden = 5,
}

export interface Collection extends Entity {
  uuid?: string;
  userId?: number;
  mateId?: number;
  mate?: Mate;
  title: string;
  description: string;
  mediazz?: Media[];
  coverMediaId?: number;
  visibility: Visibility;
  participantzz?: Mate[];

  replyId?: number;
  reply?: Reply;

  momentCount?: number;
  galGameCount?: number;
  storyBookCount?: number;
  coverMedia?: Media;
}

export type CollectionType = "moment" | "galGame" | "storyBook";

export interface CollectionItem extends Entity {
  collectionId: number;
  collectableId: number;
  collectableType: CollectionType;
  mateId?: number;
  collectable?: Moment | GalGame | StoryBook;
  order: number;

  collectableIdzz?: number[];
  dtPublish?: string;
}
